import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Leandro Baseggio | Frontend Developer', // e.g: 'Name | Developer'
  description: 'Take a look at my Portfolio.', // e.g: Welcome to my website
  lang: 'en, pt, it', // e.g: en, es, fr, jp
};

// HERO DATA
export const heroData = {
  title: '',
  name: 'Leandro Baseggio.',
  subtitle: '',
  cta: 'know more',
};

// ABOUT DATA
export const aboutData = {
  img: 'profileBaseggio.jpg',
  paragraphOne:
    "I'm a seasoned professional with 18 years experience in video and television production. I've retargeted my goals as I shifted towards my infatuation for coding and programming. Looking forward securing an instigating Frontend Development roll that brings opportunities for development and progression.",
  paragraphTwo:
    'To become a front-end developer I started by studying autonomously and in my spare time. I ended up being enchanted by the content and entered a 700-hour intensive bootcamp.',
  paragraphThree:
    'After all this schooling I am prepared to enter the job market grow and learn even more!',
  resume: 'https://drive.google.com/file/d/1A15cNVBBSRZN-6U1S4beRFCUemYk_0gG/view?usp=sharing', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'brewersHeaven.jpg',
    title: "Brewer's Heaven",
    info:
      'Web site created using React fetching a REST APIs JSON data using class components to hold the state. The information is mapped according to the different filters available to the user.',
    info2:
      'Technologies: JavaScript, React, HTML, CSS, Bootstrap, Git, GitHub, Responsiveness, Trello, Netlify. SCRUM – Agile.',
    url: 'https://brewers-heaven.netlify.app/',
    repo: 'https://github.com/Brewed-Wild/brew',
  },

  {
    id: nanoid(),
    img: 'chat-app.jpg',
    title: 'Chat-App',
    info:
      'This is my "WhatsApp". You need to login to enter and have a conversation with me. Pick one and leave me a message!',
    info2:
      'Technologies: JavaScript, React, Sockets, Rest APIs, Sending Images, React Hooks, Props, and CSS – https://chatengine.io​',
    url: 'https://chat-app-baseggio.netlify.app',
    repo: 'https://github.com/LBaseggio/chat-app.git',
  },

  {
    id: nanoid(),
    img: 'twitter_dupe.jpg',
    title: 'Twitter Dupe',
    info:
      'Website created with React and Next in order to CRUD from an Airtable "API". Uses GitHub authentication.',
    info2:
      'Next.js, StoryBook, HTML, Sass, React-Icons, Applitools, GitHub Actions, GitHub Authentication, Airtable.',
    url: 'https://twitter-dupe.netlify.app',
    repo: 'https://github.com/LBaseggio/posts-app',
  },

  {
    id: nanoid(),
    img: 'weather-app.jpg',
    title: 'Weather App',
    info:
      'Fetching a REST APIs JSON data from https://openweathermap.org/. The user can do a query for cities, states, countries or ZIP Codes.',
    info2: 'Technologies: JavaScript, React, HTML, CSS, Git, GitHub, Responsiveness, Netlify. ',
    url: 'https://my-weather-app-2021.netlify.app/',
    repo: 'https://github.com/LBaseggio/weather-app.git',
  },

  {
    id: nanoid(),
    img: 'reactCountries.jpg',
    title: 'Countries of the World',
    info:
      'One more exercise of React fetching a REST APIs JSON data. This time using Hooks and Context. The information is displayed according to the various filters presented to the user.',
    info2:
      'Technologies: JavaScript, React, HTML, CSS, Bootstrap, Git, GitHub, Responsiveness, Trello, Netlify. SCRUM – Agile.',
    url: 'https://react-countries-of-the-world.netlify.app/',
    repo: 'https://github.com/LBaseggio/react-countries.git',
  },

  {
    id: nanoid(),
    img: 'breakingBad.jpg',
    title: 'Breaking Bad Rest API',
    info: 'This was one more exercise on REST APIs fetching data using class components and Hooks.',
    info2: 'Technologies: React, HTML, CSS, Responsiveness, Git and GitHub',
    url: 'https://breaking-bad-rest-api.netlify.app/',
    repo: 'https://github.com/LBaseggio/breaking-bad-api.git',
  },

  {
    id: nanoid(),
    img: 'theDigitalSheriff.jpg',
    title: 'The Digital Sheriff',
    info:
      'As a result of a 48h hackathon me and my team created this site in the context of a "Technology to be taken to the past"',
    info2: ' Technologies: React, HTML, CSS, Responsiveness, Git, GitHub, SCRUM & Agile',
    url: 'https://the-digital-sheriff.netlify.app/',
    repo: 'https://github.com/LBaseggio/the-digital-sheriff.git',
  },

  // {
  //   id: nanoid(),
  //   img: 'project.jpg',
  //   title: '',
  //   info: '',
  //   info2: '',
  //   url: '',
  //   repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  // },
];

// CONTACT DATA
export const contactData = {
  cta: 'email',
  btn: 'email',
  email: 'leandro.baseggio@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    // {
    //   id: nanoid(),
    //   name: 'twitter',
    //   url: '',
    // },
    // {
    //   id: nanoid(),
    //   name: 'codepen',
    //   url: '',
    // },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/leandro-baseggio/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/LBaseggio',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
